export { default } from "ember-cookies/services/cookies";
